import React from 'react';
import { useField } from 'formik';
import MuiPhoneInput from 'material-ui-phone-number';
import { useTranslation } from 'react-i18next';

import { TextFieldProps } from '@material-ui/core/TextField';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { getErrorMessageKey } from 'helpers/helpers';
import localization from './countries.js';
import { formPhoneFieldTheme } from './styles';

interface Props {
  name: string;
  label: string;
  readOnly?: boolean;
}

const FormPhoneField: React.FC<Props & TextFieldProps> = ({ name, label, readOnly, ...props }) => {
  const [field, meta, helpers] = useField(name);
  const { t } = useTranslation();

  const errorMessage = meta.error ? t(getErrorMessageKey(meta.error)) : '';

  return (
    <MuiThemeProvider theme={formPhoneFieldTheme}>
      <MuiPhoneInput
        fullWidth
        defaultCountry="cz"
        label={label}
        variant="outlined"
        error={!!meta.error}
        helperText={errorMessage}
        preferredCountries={['cz', 'sk']}
        localization={localization}
        {...field}
        {...props}
        onChange={(value: string) => {
          helpers.setValue(value);
        }}
        readOnly={readOnly}
      />
    </MuiThemeProvider>
  );
};

export default FormPhoneField;
